let config = require('./config')
let utils = require('@common/utils')
let request = require('@common/request')
let iBorad = require('@common/iBorad')
require('@common/old.api')
let mask = require('../../modules/mask/index')

_qblog.setting({key: 20016, tcss: true});


//AMS新集成
zHttp.baseUrl = "http://iyouxi3.vip.qq.com/ams3.0.php";
//活动地址 不带任何参数
var _pageUrl = location.protocol + '//' + location.host + location.pathname;

var qb_guid = 0; // window.external.getGuid 有可能不返回数据
var getGuid = function () {
  try {
  //  var guid = qbsdk.getServerGuid();
    qb_guid = qbsdk.getGuid();
    console.log("guid--->"+qb_guid);
  }catch(e){
    var web_page_extension_id = '{A3C609B3-3E61-4508-8953-117B7286068B}';
    var platform_extension_id = '{420DEFEE-20A8-468C-BFDA-61A09A99325D}';
    var extension;
    try {
      extension = window.getExtension(web_page_extension_id);
      extension.sendMessage(platform_extension_id, {serviceId: "hardware.getGuid", args: []}, function (data) {
        qb_guid = data[0].split('-').join('');
      });
    }catch(e){
      qb_guid = 0;
    }
  }
};
getGuid();


function hint(){
  var qb_dialog = new qv.zero.Dialog({
    title: "QQ浏览器用户专享",
    content: "<p style='color: #333'>       亲，这是QQ浏览器用户的专属特权活动。</p><p style='color: #333'>             用QQ浏览器打开即可参加。</p>",
    type: "alert",
    buttons: [{
      text: "下载QQ浏览器",
      click: function() {
        document.getElementById('downloadQBBtn').click();
        qb_dialog.hide();
      }
    }]
  });
  hint = function(){
    qb_dialog.show();
  };
  qb_dialog.show();
}

var reportDownloadQB = function () {
  var adtag = zURL.get('ADTAG');
  if(adtag) {
    _qblog.wsd.click('BROWSER.ACTIVITY.DNF201808.QBDOWNLOADCLICK_' + adtag);
  }
  _qblog.wsd.click('BROWSER.ACTIVITY.DNF201808.QBDOWNLOADCLICK');
};

var jumentBrowser=function (){
    return /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent) || /(Android)/i.test(navigator.userAgent)
  }
;(function(window,$){
  function getQBVersion(){
    var version = 0;
    try{
      try{
        version= window.external.getVersion() || 1;
      }catch(e){
        version = window.external.getbrowserversion() || 1;
      }
    }catch(e){
      if (/QQBrowser/.test(navigator.userAgent)) {
        version = 1;
        try {
          version = /QQBrowser\/([\d.]+)\b/.exec(navigator.userAgent)[1];
          if (version === '9.0.2524.400') {
            version = 0;
          }
        }
        catch(e) {}
      }
    }
    if (jumentBrowser()){
      version = 0;
    }
    return version;
  }
  function isQQBrowser(){
    var version = getQBVersion();
    var result = (version !== 0);
    return result;
  }
  window.isQQBrowser = isQQBrowser()
})(window,jQuery);
window.setUserContact = function(){
  userAddress.getUserInfo(function(res){
    var userDialog = new qv.zero.Dialog({
      title: "填写联系方式",
      content: userAddress.tempContact(res),
      type: "show",
      buttons: [{
        text: "提交",
        click: function() {
          userAddress.submitUserInfo("userName","phoneNum","detailAddr","zipCode",function(){
            alert("保存成功！");
            userDialog.hide();
          })
        }
      }]
    });
    userDialog.show();
  });
};
//签到 设置按钮 显示天数
function setMoney(demo, m){
  var me = jQuery(demo);
  var meVal = parseInt(me.text());
  var k = 0;
  if(parseInt(m) < 0) {
    k = meVal + parseInt(m);
  } else if (m === '++') {
    k = meVal + 1;
  } else if (m === '--') {
    k = meVal - 1;
  } else if(!isNaN(m)) {
    if(m.toString().indexOf('-') >= 0 || m.toString().indexOf('+') >= 0) {
      k = meVal + parseInt(m);
    } else {
      k = m;
    }
  }
  if(k < 0){
    k = 0;
  }
  me.text(k);
}

/*分页*/
(function (window,$) {

  var me = {
    init:function(args){
      return (function(){
        args.pageCount = parseInt((args.dataContainer.length - 1) / args.perPage) + 1;
        me.fillHtml(args);
        me.bindEvent(args);
      })();
    },
    //填充html
    fillHtml:function(args){
      return (function(){
        args.liftsContainer.empty();
        args.pageContainer.empty();
        //第一页
        if(args.firstAndLast) {
          if(args.current > 1){
            args.pageContainer.append('<a href="javascript:;" class="firstPage">第一页</a>');
          } else {
            args.pageContainer.append('<span class="disabled">第一页</span>');
          }
        }
        //上一页
        if(args.current > 1){
          args.pageContainer.append('<a href="javascript:;" class="prevPage">上一页</a>');
        }else{
          args.pageContainer.remove('.prevPage');
          args.pageContainer.append('<span class="disabled">上一页</span>');
        }
        //中间页码
        args.pageContainer.append('<span>第'+ args.current +'/'+ args.pageCount +'页</span>');
        //下一页
        if(args.current < args.pageCount){
          args.pageContainer.append('<a href="javascript:;" class="nextPage">下一页</a>');
        }else{
          args.pageContainer.remove('.nextPage');
          args.pageContainer.append('<span class="disabled">下一页</span>');
        }
        //最后一页
        if(args.firstAndLast) {
          if(args.current < args.pageCount){
            args.pageContainer.append('<a href="javascript:;" class="lastPage">最后一页</a>');
          } else {
            args.pageContainer.append('<span class="disabled">最后一页</span>');
          }
        }
        //列表
        var _star = (args.current - 1) * args.perPage,
          _end = args.current * args.perPage;
        args.liftsContainer.append(args.dataContainer.slice(_star, _end).join(''));
        if(typeof(args.backFn)=="function"){
          args.backFn({current: args.current});
        }
      })();
    },
    //绑定事件
    bindEvent:function(args){
      return (function(){
        //上一页
        args.pageContainer.on("click","a.prevPage",function(){
          if(args.current > 1) {
            args.current--;
          }
          me.fillHtml(args);
        });
        //下一页
        args.pageContainer.on("click","a.nextPage",function(){
          if(args.current < args.pageCount) {
            args.current++
          }
          me.fillHtml(args);
        });
        //第一页、最后一页
        if(args.firstAndLast) {
          args.pageContainer.on("click","a.firstPage",function(){
            args.current = 1;
            me.fillHtml(args);
          });
          args.pageContainer.on("click","a.lastPage",function(){
            args.current = args.pageCount;
            me.fillHtml(args);
          });
        }
      })();
    }
  };
  window.createPage = function (options) {
    var args = $.extend(
      {
        dataContainer: [],
        liftsContainer: $('#liftsContainer'),//列表容器
        pageContainer: $('#pageContainer'),//分页容器
        perPage : 10,//每页显示数
        pageCount : 0,//总页数
        current : 1,//当前页码
        startPage : 1,//初始页
        firstAndLast: false,//是否显示第一页、最后一页
        backFn : function(){}
      },
      options
    );
    me.init(args);
  }
})(window, jQuery);

//main
var Page = qv.zero.extend(qv.zero.AbstractPage, {
  // 项目ID
  userJsonID:311522,  //极为重要，如果活动id 不对，整个页面不响应 事件
  preloads: ["AreaSvrSelector"],
  loadExtHandler: true,
  init: function () {
    Page.superclass.init.apply(this, arguments);
  },
  initEvent: function () {
    Page.superclass.initEvent.apply(this, arguments);
    $('body').on('click', 'a[href="#"]', function (e) {
      e.preventDefault();
    });
    page.svr = new qv.zero.AreaSvrSelector({
      game: 'dnf'
    });
    if(!!qq.login.getUin()) {
      page.queryGold();
      page.querySilver();
      page.queryDays();
    }
    qq.login.bind('login', function () {
      page.queryGold();
      page.querySilver();
      page.queryDays();
    });
    qq.login.bind('logout', function () {
      setMoney('#day',0);
      setMoney('#chance',0);
      $('.silver').removeClass('open');
      $('.openGold').removeClass('open');
      $('.openSilver').removeClass('open');
      $('.gold').removeClass('open');
    });

    $(".feed .feedBack").click(function () {
      _qblog.wsd.click("RELEASEMEBABY.SUPPORT");
    });

  },//initEvent 结束
  //领取礼包
  exchange: function(e,act) {
    var actArr = [311722,311705,311617 ],// 最好一个 QQ浏览器签到礼包
      index = act[0],
      _actid = actArr[index];

    if(!isQQBrowser){
      hint();
      return;
    }
    if(!qb_guid) {
      getGuid();
    }
    zUtil.ensureLogin(function(){
      page.svr.show({
        send: function (args, callb) {
          zHttp.send({actid: _actid, area: args.area, roleid: args.roleid, guid: qb_guid}, function (res) {
            if (res.ret == 0) {
              zHttp.showResponse(res, res.actid, $.noop);
              // zMsg.dialog("恭喜你获得CDKey,CDKey是："+res.data.op.cdkey,"dnf-dark",[
              //     {
              //       text: "去兑换",
              //       click: function() {
              //         window.open("http://dnf.qq.com/gift.shtml")
              //       }
              //     }
              //   ]);
            } else if (res.ret == 10002) {
              qq.login.open();
            } else if (res.ret == 10001 || res.ret == 10004){
              zMsg.alert("活动已经结束，敬请期待更多QQ浏览器特权活动！");
            } else {
              zHttp.showResponse(res, res.actid, $.noop);
            }
            console.log("exchange--id-->"+_actid);
            console.log(res.ret);
          })
        }
      });
    });
    _qblog.wsd.click('BROWSER.ACTIVITY.DNF201808.EXCHANGE_' + index);
  },
  signin: function () {
    if(!isQQBrowser){
      return;
    }
    zHttp.send({actid: 311748}, function (res) {
      if (res.ret == 0) {
        setMoney('#day','++');
      }
    })
  },
  queryGold: function () {
    zHttp.send({ actid: 311746 }, function(res){
      if (res.ret == 0) {
        if (res.data.op.join['311538'] > 0) {//终极冲奖id
          // $('.gold').addClass('open');
          // $('.openGold').addClass('open');
          console.log("gold box is opened!!!");
        }
      }
    });
  },
  querySilver: function () {//查询每天是否领取
    zHttp.send({ actid: 311745 }, function(res){
      if (res.ret == 0) {
        if (res.data.op.join['311542'] > 0) {//每天抽奖
          $('.silver').addClass('open');
          $('.openSilver').addClass('open');
          console.log("already has -->"+ 311745);
        }
        console.log("not --has -->"+ 311745);
      }
    });
  },
  //查询登录天数，抽奖天数
  queryDays : function(){
    zUtil.ensureLogin(function() {
      zHttp.send({ actid: 311744 }, function(res){
        if (res.ret == 0) {
          var m = res.data.op;
          setMoney('#day', m);
          var t = res.data.rule.join_level;
          setMoney('#chance', t);
        }else{
          console.warn("查询天数 失败 "+res.ret);
        }
        page.signin();
      });
    });
  },
  //打开宝箱动画
  openBX: function (cb,flag) {
    if (flag == 1) {
      $('.silver').addClass('open');
      $('.openSilver').addClass('open');
      setTimeout(function(){
        cb();
      }, 200);
    } else if (flag == 2) {
      $('.gold').addClass('open');
      $('.openGold').addClass('open');
      setTimeout(function(){
        cb();
      }, 200);
    }
  },
  getLuckySilver: function(e,act){
    if(!isQQBrowser){
      hint();
      return;
    }
    if(!qb_guid) {
      getGuid();
    }
    // if($('.silver').hasClass('open')) {
    //   return;
    // }
    zUtil.ensureLogin(function(){
      page.svr.show({
        send: function (args, callb) {//每天抽奖
          // 记录奖品时 必须加字段 _record_gift_flow : 1 ， 若记录末等奖时 再加字段(不记录则不加) _record_def_gift : 1
          zHttp.send({actid: 311542, area: args.area, roleid: args.roleid,  guid: qb_guid,_record_gift_flow : 1, _record_def_gift : 1}, function (res) {
            if (res.ret == 0){
              setMoney('#chance','++');
              page.openBX(function () {
                zHttp.showResponse(res, res.actid, $.noop);
              },1);

            } else if (res.ret == 10002) {
              qq.login.open();
            } else if (res.ret == 10001 || res.ret == 10004) {
              zMsg.alert("活动已经结束，敬请期待更多QQ浏览器特权活动！");
            } else {
              zHttp.showResponse(res, res.actid, $.noop);
            }
            console.log('silver--->'+res.ret);
          });
        }
      });
    });
    _qblog.wsd.click('BROWSER.ACTIVITY.DNF201808.GETLUCKYSILVERCLICK');
  },
  getLuckyGold: function(e,act){
    if(!isQQBrowser){
      hint();
      return;
    }
    if(!qb_guid) {
      getGuid();
    }
    // if($('.gold').hasClass('open')) {
    //   return;
    // }
    zUtil.ensureLogin(function(){
      page.svr.show({
        send: function (args, callb) {
          // 记录奖品时 必须加字段 _record_gift_flow : 1 ， 若记录末等奖时 再加字段(不记录则不加) _record_def_gift : 1
          zHttp.send({actid: 311538, area: args.area, roleid: args.roleid,  guid: qb_guid,_record_gift_flow : 1, _record_def_gift : 1}, function (res) {
            if (res.ret == 0){
              page.openBX(function () {
                zHttp.showResponse(res, res.actid, $.noop);
              },2);
            } else if (res.ret == 10002) {
              qq.login.open();
            } else if (res.ret == 10001 || res.ret == 10004) {
              zMsg.alert("活动已经结束，敬请期待更多QQ浏览器特权活动！");
            } else {
              zHttp.showResponse(res, res.actid, $.noop);
            }
          });
        }
      });
    });
    _qblog.wsd.click('BROWSER.ACTIVITY.DNF201808.GETLUCKYGOLDCLICK');
  },
  //查询中奖记录
  queryRecord: function () {
    zUtil.ensureLogin(function () {
      zHttp.send({actid: 311747}, function (res) {
        var testOp = '';
        //             testOp = [{
        //     "key": 0,
        //     "val": {
        //         "actid": 276370,
        //         "status": 0,
        //         "type": 1,
        //         "is_life_coupon": "0",
        //         "qqvipCardId": 0,
        //         "time": 1524549748,
        //         "endTime": "-",
        //         "name": "\u6df1\u6e0a\u6d3e\u5bf9\u901a\u884c\u8bc1*6",
        //         "level": 5,
        //         "info": "EGWLMAAAAAAdatbe"
        //     }
        // }, {
        //     "key": 1,
        //     "val": {
        //         "actid": 276362,
        //         "status": 0,
        //         "type": 1,
        //         "is_life_coupon": "0",
        //         "qqvipCardId": 0,
        //         "time": 1524553109,
        //         "name": "\u6d4f\u89c8\u5668\u4e13\u5c5e\u793c\u5305",
        //         "level": 4,
        //         "info": "EGWANAAAAAAbF"
        //     }
        // }, {
        //     "key": 2,
        //     "val": {
        //         "actid": 276364,
        //         "status": 0,
        //         "type": 1,
        //         "is_life_coupon": "0",
        //         "qqvipCardId": 0,
        //         "time": 1524553444,
        //         "name": "QQ\u6d4f\u89c8\u5668\u7b7e\u5230\u793c\u5305",
        //         "level": 3,
        //         "info": "EGWBDAAAAAAUG"
        //     }
        // }, {
        //     "key": 3,
        //     "val": {
        //         "actid": 276364,
        //         "status": 0,
        //         "type": 1,
        //         "is_life_coupon": "0",
        //         "qqvipCardId": 0,
        //         "time": 1524553444,
        //         "name": "QQ\u6d4f\u89c8\u5668\u7b7e\u5230\u793c\u5305",
        //         "level": 2,
        //         "info": "EGWBDAAAAAAUG"
        //     }
        // }, {
        //     "key": 4,
        //     "val": {
        //         "actid": 276364,
        //         "status": 0,
        //         "type": 1,
        //         "is_life_coupon": "0",
        //         "qqvipCardId": 0,
        //         "time": 1524553444,
        //         "name": "QQ\u6d4f\u89c8\u5668\u7b7e\u5230\u793c\u5305",
        //         "level": 1,
        //         "info": "EGWBDAAAAAAUG"
        //     }
        // }];
        if (res.ret == 0) {
          var records = testOp || res.data.op;
          var _htmlArr = [],
            _html = '',
            pageHtml = '',
            PageCount = 0;
          for (var i = records.length - 1; i >= 0; i--) {
            var obj = records[i].val,
              time = qv.date.format("Y-m-d H:i:s", obj.time * 1000),
              name = obj.name,
              level = obj.level,
              cdkey = obj.info ? obj.info : '',
              btn = '';
            if ((level == 1 || level == 2 || level == 3) && (cdkey.length!==16)) {
              btn = '<a href="javascript:;" onclick="setUserContact();">填写联系方式</a>';
              cdkey = '-';
            } else if (level == 4 && (cdkey.length!==16)) {
              btn = '<a href="http://my.pay.qq.com/account/#index" target="_blank">我的账户</a>';
              cdkey = '-';
            } else {
              btn = '<a href="http://dnf.qq.com/gift.shtml" target="_blank">兑换</a>';
              cdkey = obj.info;
            }
            _htmlArr.push('<tr><td>' + time + '</td><td>' + name + '</td><td>' + cdkey + '</td><td>' + btn + '</td></tr>');
            PageCount++;
          }
          if (PageCount == 0) {
            _htmlArr.push('<tr><td colspan="4" class="noGifts">您尚未获得任何礼包</td></tr>');
          }
          _html = '<table width="100%" class="giftsLists">\
                                    <thead><tr><th>获得时间</th><th>礼包内容</th><th>CDKEY</th><th>操作</th></tr></thead>\
                                    <tbody id="giftsContainer"></tbody>\
                                </table>\
                                <div id="pageContainer"></div>';
          var giftsDialog = new qv.zero.Dialog({
            width: 600,
            title: "查询获奖记录",
            content: _html,
            type: "show",
            buttons: [{
              text: "确定",
              click: function () {
                giftsDialog.hide();
              }
            }]
          });
          giftsDialog.show();
          var _createPage =  window.createPage({
            dataContainer: _htmlArr,//列表数据 Array类型
            liftsContainer: $('#giftsContainer'),//列表容器
            pageContainer: $('#pageContainer'),//分页容器
            backFn: function (p) {
              //解决dialog弹框自动居中，若未使用zMsg弹框，可删除
              $(window).resize();
            }
          })
        } else if (res.ret == 10002) {
          qq.login.open();
        } else if (res.ret == 10001 || res.ret == 10004) {
          zMsg.alert("活动已经结束，敬请期待更多QQ浏览器特权活动！");
        } else {
          zHttp.showResponse(res, res.actid, $.noop);
        }
      })
    });
    _qblog.wsd.click("BROWSER.ACTIVITY.DNF201808.QUERYRECORDCLICK");
  }

});
window.page = new Page()



// WEBPACK FOOTER //
// ./pages/index/index.js